export class FormValidator {
  static RegExOnlyNumbers = /^[0-9]+$/;
  static RegExOnlyLetters = /^[A-Za-z]+$/;
  // eslint-disable-next-line
  static RegExOnlyAscii = /^[\x00-\x7F]*$/;

  /* Src: http://emailregex.com/ */
  static RegExValidMail =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  static RegExMobilePhoneNumber = /( (^\+)|(^01[5-7][1-9]))([\s\d]){5,25}$/;
  static RegExPhoneNumber = /((^\+)|(^0))([0-9]{5,25})$/;

  static RegExContainsNumber = /\d+/;
  static RegExContainsLetters = /[A-Za-z]+/;
  static RegExContainsSpecialCharacters = /[*+'#´`_.:,;/()=?&%$§"^°€]/;

  static isValidFirstOrLastName(name: string) {
    return (
      name !== null &&
      name.length >= 2 &&
      !this.RegExContainsNumber.test(name) &&
      !this.RegExContainsSpecialCharacters.test(name)
    );
  }

  static isNumeric(n: string) {
    return this.RegExOnlyNumbers.test(n);
  }

  static containsAsciiCharsOnly(str: string) {
    return this.RegExOnlyAscii.test(str);
  }

  static isValidMailAddress(mailAddress: string) {
    return this.RegExValidMail.test(mailAddress);
  }

  static isValidPhoneNumber(phoneNumber: string) {
    // Only test phone numbers without any whitespace or dash to ensure number length.
    return this.RegExPhoneNumber.test(phoneNumber.replace(/\s+/g, '').replace(/[-]+/g, ''));
  }

  static isValidStreet(street: string) {
    return street.length > 2;
  }

  static isValidHouseNumber(houseNumber: string) {
    return houseNumber.length >= 1 && this.RegExContainsNumber.test(houseNumber);
  }

  static isValidZIPCode(zipCode: string) {
    return zipCode.length === 5 && this.isNumeric(zipCode);
  }

  static isValidCity(city: string) {
    return city.length > 2;
  }

  static isValidFutureDate(date: Date) {
    return date > new Date();
  }
}
